import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
    Select,
    MenuItem,
    Checkbox,
    Radio,
    FormControlLabel,
    FormGroup,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    questions: any[];
    onDelete?: (questionId: string) => void;
    onChange?: (customQuestionId, subQuestionId: string, value: string | string[]) => void;
};

const RenderCustomQuestions = ({ questions, onDelete, onChange }: Props) => {
  const [checkedValues, setCheckedValues] = useState([]);

  const renderField = (customQuestion, question) => {
    const style = { width: '100%' };
    const isDisabled = Boolean(onDelete);

    const onChangeValue = (e) => {
      onChange(customQuestion._id, question._id, e.target.value);
    }

    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;

      let newValues = [];

      if (checked) {
        newValues = [...checkedValues, value];
      } else {
        newValues = (checkedValues.filter((item) => item !== value));
      }

      setCheckedValues(newValues);

      onChange(customQuestion._id, question._id, newValues.join(','));
    };

    const handleRadioChange = (event) => {
      const { value, checked } = event.target;

      let newValues = [];

      if (checked) {
        newValues = [...checkedValues, value];
      } else {
        newValues = (checkedValues.filter((item) => item !== value));
      }

      setCheckedValues(newValues);

      onChange(customQuestion._id, question._id, newValues.join(','));
    };

    let field = <TextField style={style} disabled={isDisabled} onChange={onChangeValue} />

    if (question.type === 'textarea') {
      field = <TextField multiline minRows={4} style={style} disabled={isDisabled} onChange={onChangeValue} />
    }

    if (question.type === 'select') {
      field = (
        <Select style={style} disabled={isDisabled} onChange={onChangeValue}>
          {(question.options || '').split('\n').map((option, index) => {
            return <MenuItem key={index} value={option}>{option}</MenuItem>
          })}
        </Select>
      );
    }

    if (question.type === 'checkbox') {
      field = (
        <FormGroup>
          {(question.options || '').split('\n').map((option, index) => {
            return (
              <FormControlLabel
                control={<Checkbox key={index} disabled={isDisabled} value={option} onChange={handleCheckboxChange} />}
                label={option}
              />
            )
          })}
        </FormGroup>
      );
    }

    if (question.type === 'multichoices') {
      field = (
        <FormGroup>
          {(question.options || '').split('\n').map((option, index) => {
            return (
              <FormControlLabel
                control={<Radio key={index} disabled={isDisabled} value={option} onChange={handleRadioChange} />}
                label={option}
              />
            )
          })}
        </FormGroup>
      );
    }

    return field
  }

  return (
    questions.map((customQuestion, index) => {
      return (
        <div className='custom-question-form' key={index}>
          <h4>{customQuestion.name}</h4>

          { onDelete ? <CloseIcon className='delete-icon' onClick={() => onDelete(customQuestion._id)} /> : null }

          <TableContainer component={Paper}>
            <Table>
              <TableBody>
                {customQuestion.questions.map((question) => (
                  <TableRow
                    key={question._id}
                  >
                    <TableCell style={{ width: '400px' }}>{question.title} <span style={{ color: 'red' }}>*</span></TableCell>
                    <TableCell>{renderField(customQuestion, question)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )
    })
  );
};

export default RenderCustomQuestions;
